<template>
  <div class>
    <button class="btn_blue" @click.prevent="show">
      Ny
    </button>
    <modal name="modal-create" :adaptive="true" height="auto" :scrollable="true" :width="450" @opened="opened">
      <div class="px-5 py-5">
        <h2 class="mb-4 text-xl tracking-wide">NY APIRESURS</h2>

        <ValidationObserver ref="form" v-slot="{ invalid }">
          <form @submit.prevent="onCreate()">
            <div class="space-y-4">
              <div>
                <ValidationProvider v-slot="{ errors }" name="Namn" rules="required">
                  <span class="form-label">Namn</span>
                  <input v-model="apiresource.name" type="text" class="w-full mt-1 form-input" :class="{
                    'border-red-600 focus:border-red-600': errors[0]
                  }" />
                  <span class="block mt-1 text-sm text-red-500">{{
                  errors[0]
                }}</span>
                </ValidationProvider>
              </div>
              <div>
                <ValidationProvider v-slot="{ errors }" name="Visningsnamn" rules="required">
                  <span class="form-label">Visningsnamn</span>
                  <input v-model="apiresource.displayName" type="text" class="w-full mt-1 form-input" :class="{
                    'border-red-600 focus:border-red-600': errors[0]
                  }" />
                  <span class="block mt-1 text-sm text-red-500">{{
                  errors[0]
                }}</span>
                </ValidationProvider>
              </div>
              <div>
                <ValidationProvider v-slot="{ errors }" name="Beskrivning" rules="max:250">
                  <span class="form-label">Beskrivning</span>
                  <textarea rows="4" v-model="apiresource.description" type="text" class="w-full mt-1 form-input" :class="{
                    'border-red-600 focus:border-red-600': errors[0]
                  }" />
                  <span class="block mt-1 text-sm text-red-500">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
              </div>
            <div class="flex justify-end mt-10 mb-1">
              <button type="submit" class="block btn_blue" :class="{ 'opacity-50': invalid }" :disabled="invalid">Spara</button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      apiresource: {
        name: "",
        dislayName: "",
        description: ""
      }
    };
  },

  methods: {
    ...mapActions("apiresourcesStore", ["add"]),
    show() {
      this.$modal.show("modal-create");
    },
    opened() {
      // this.cart.description = "";
      // this.$refs.description.focus();
    },
    async onCreate() {
      await this.add(this.apiresource);
      this.$modal.hide("modal-create");
    }
  }
};
</script>
